import MDEditor from "@uiw/react-md-editor";
import "@uiw/react-md-editor/markdown-editor.css";

const MarkdownEditor = ({ value, setValue }) => {
  return (
    <div className="w-full rounded-xl shadow-sm !bg-white">
      <MDEditor value={value} onChange={setValue} theme="light" data-color-mode="light" height={600} />
    </div>
  );    
};

export default MarkdownEditor;
